import mock from 'src/utils/mock';

mock.onGet('/publisher/catalogue/all').reply(200, [
  {
    catalogueId: '08b0b828-3be7-4454-9628-4c71ca7b19da',
    catalogueName: 'gsdgdsgd',
    category: {
      categoryId: '92466fe0-5062-45d1-862a-8222bf9d5cf4',
      categoryName: 'IES',
      subCategory: {
        subCategoryId: 'd960701b-1af0-4f5e-9578-bc52eb03b5c3',
        subCategoryName: 'IEE',
      },
    },
    description: 'sgdsgdsg',
    packageGroupCode: 'demoGroup',
    packageCode: 'demoPackage',
    features: false,
    internalStudent: true,
    student: false,
    previewVideos: [
      {
        previewId: 'c8b31795-732f-4658-adf7-e4f064718e4c',
        subjectName: null,
        videoUrl:
          'https://d1k3nlqshgkoey.cloudfront.net/preview_videos/preview_videos/0be61689-891d-4d8b-9f45-3291bbcdaf3e-SampleVideo_1280x720_1mb.mp4',
        thumbnail:
          'https://d1k3nlqshgkoey.cloudfront.net/preview_videos/preview_videos/093ec90e-6da4-4aaf-b334-218e0819658e-d09f54d2-a203-4446-947d-44ac1b361fec.png',
      },
    ],
    instructors: [],
    resources: [],
    imageName: 'Card 2.png',
    imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 2.png',
    colour: '233.215.215.#e9d7d7',
    coupons: [
      {
        couponId: '7b67a3a3-540e-4540-9518-069c10e5598e',
        couponName: 'Early Bird Offer',
        discount: 15,
        amount: false,
        actual: true,
      },
      {
        couponId: 'ee62c7e9-b0fe-4245-89e1-9b6c73a6a4af',
        couponName: 'DIWALIOFFER4',
        discount: 400,
        amount: true,
        actual: true,
      },
    ],
    subScriptions: [
      {
        subScriptionId: '666d65e0-11ae-41a2-ad44-9781ac6f8062',
        label: 'hfh',
        subscriptionType: '5',
        fixed: false,
      },
    ],
    prices: [
      {
        priceId: 'ea946179-e1a2-4088-86aa-b35907c1dedd',
        expire: null,
        fixed: false,
        subscriptionType: '5',
        label: 'hfh',
        actualPrice: 15222,
        finalPrice: 444,
        discountName: 'gdgsd',
        discount: 97.08316909735909,
      },
    ],
    subjects: [
      {
        subjectId: 'b6cbe5db-b47c-41ac-a4d7-04b076ae773e',
        subjectName: 'Quiz subject',
        imagePath: '',
        videos: 3,
        hours: 39,
        units: 2,
        comingSoon: false,
        tags: [],
      },
    ],
    tags: [],
    requestType: null,
  },
  {
    catalogueId: '09716bfd-1d9a-4a86-9348-cf191fb8ef07',
    catalogueName: 'EEEE and ECE',
    category: {
      categoryId: 'c047c681-f4ea-4fe4-8d1d-e13824218fd9',
      categoryName: 'mmmm',
      subCategory: {
        subCategoryId: '5ee2eac3-95c2-4d04-a2b6-bc8c20beb7ef',
        subCategoryName: 'maths1',
      },
    },
    description: 'EEEE and ECE',
    packageGroupCode: 'demoGroup',
    packageCode: 'demoPackage',
    features: true,
    internalStudent: false,
    student: false,
    previewVideos: [
      {
        previewId: 'e1b6bdf4-e39e-49df-86d6-f00babcfa15c',
        subjectName: null,
        videoUrl:
          'https://d1k3nlqshgkoey.cloudfront.net/preview_videos/preview_videos/1548b630-173b-4b3a-8055-be298fd39745-SampleVideo_1280x720_1mb.mp4',
        thumbnail:
          'https://d1k3nlqshgkoey.cloudfront.net/preview_videos/preview_videos/0d89d376-2c07-4457-bfb7-b62e3df54371-d09f54d2-a203-4446-947d-44ac1b361fec.png',
      },
    ],
    instructors: [
      {
        instructorId: '08ba433e-1927-49b9-bebb-3c223444e306',
        instructorName: 'iol .ui',
        role: null,
        description: 'u;i;',
        photo:
          'https://d1k3nlqshgkoey.cloudfront.net/instructors/73f87741-184d-41cf-836a-17f544288413-image.jpg',
        resume:
          'https://d1k3nlqshgkoey.cloudfront.net/instructors/e7216899-22c0-4ff3-872b-5e889bb56519-DEEP LEARN.pdf',
      },
    ],
    resources: [],
    imageName: 'Card 3.png',
    imagePath: 'https://d1k3nlqshgkoey.cloudfront.net/Card 3.png',
    colour: '148.201.247.#94c9f7',
    coupons: [],
    subScriptions: [
      {
        subScriptionId: '63c47a2f-ee6a-4eee-8f6d-16b3bacc7c44',
        label: 'SECOND',
        subscriptionType: '2020-01-07',
        fixed: true,
      },
    ],
    prices: [
      {
        priceId: 'c770bff7-4f21-4d92-89b5-6352711c7ddc',
        expire: '2020-01-07',
        fixed: true,
        subscriptionType: '2020-01-07',
        label: 'SECOND',
        actualPrice: 7000,
        finalPrice: 6500,
        discountName: 'Discount-7',
        discount: 7.142857142857142,
      },
    ],
    subjects: [
      {
        subjectId: '0f10f310-6b2a-4916-9e28-3e1e07ca73bb',
        subjectName: 'COMPUTER ORGANISATION',
        imagePath: '',
        videos: 2,
        hours: 6,
        units: 2,
        comingSoon: false,
        tags: [],
      },
      {
        subjectId: '6337e028-21d8-41bb-a194-247dc029233b',
        subjectName: 'Create-1',
        imagePath: '',
        videos: 13,
        hours: 1,
        units: 5,
        comingSoon: false,
        tags: [],
      },
    ],
    tags: [],
    requestType: null,
  },
]);
